<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center elt-content">
                        <mat-icon color="primary" class="title-icon">supervised_user_circle</mat-icon>
                        <h1 class="secondary-font">Compte Utilsateur</h1>
                        <span  color="accent" class="w-100">Je souhaite me connecter en tant que ! 
                            </span>
                    </div>
                    <div fxLayout="row wrap" fxLayoutAlign="center center">
                        <button mat-raised-button class="uppercase" (click)="switchAccountUser('locataire')">
                            <mat-icon class="mr-1">person</mat-icon>
                            Locataire
                        </button>
                        <button mat-raised-button color="primary" class="uppercase" (click)="switchAccountUser('proprietaire')">
                            <mat-icon class="mr-1">supervisor_account</mat-icon>
                            Propriétaire
                        </button>
                        <button mat-raised-button color="primary" class="uppercase" (click)="switchAccountUser('proprietaire')">
                            <mat-icon class="mr-1">domain</mat-icon>
                            Entreprise
                        </button>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center" style="margin-left: 15px; margin-right: 15px;">
                        <span class="text-muted" >
                            Avec <strong>SILOKA</strong> Accédez à des véhicules disponibles partout au Senegal <br> <strong>24h/24 et 7j/7</strong>
                        </span> 
                    </div>                   
                </div>
            </div>
        </mat-card>
    </div>
</div>
